import React, { Fragment, useContext, useEffect, useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import { connect } from 'react-redux';
import PageLoader from '../Loader/PageLoader';
import { ToastNotificationContext } from '@context/ToastNotificationContext';
import { AdminActions } from '@adapters/redux/reducer/admin';
import { fullBackendPath } from 'core/helpers';

const Page = (props) => {
  const { notifySuccess, notifyError } = useContext(ToastNotificationContext);
  const { updateData, updating, intro_section, video_banner } = props;
  const {
    id,
    describe: describeIntro,
    describe_vi: describeVieIntro,
    title: titleIntro,
    title_vi: titleVieIntro,
    link: linkIntro,
    intro_image1,
    intro_image2,
    intro_image3,
  } = intro_section;
  const {
    title: titleVideo,
    title_vi: titleVieVideo,
    link: linkVideo,
    video_background,
  } = video_banner;

  const [describe, setDescribe] = useState(describeIntro);
  const [describeVie, setDescribeVie] = useState(describeVieIntro);
  const [title, setTitle] = useState(titleIntro);
  const [titleVie, setTitleVie] = useState(titleVieIntro);
  const [link, setLink] = useState(linkIntro);
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);

  const [titleV, setTitleV] = useState(titleVideo);
  const [titleVVie, setTitleVVie] = useState(titleVieVideo);
  const [linkV, setLinkV] = useState(linkVideo);
  const [imageV, setImageV] = useState(null);

  const onSubmitIntroduction = () => {
    const params = {
      title,
      title_vi: titleVie,
      describe,
      describe_vi: describeVie,
      link,
      images: [],
    };

    if (image1)
      params.images.push({
        field: 'intro_image1',
        image: image1,
      });

    if (image2)
      params.images.push({
        field: 'intro_image2',
        image: image2,
      });

    if (image3)
      params.images.push({
        field: 'intro_image3',
        image: image3,
      });

    updateData('put', 'intro/1', params, 'intro_section', (isError, error) => {
      if (isError) {
        notifyError(error);
      } else {
        notifySuccess('Update introduction successfully');
        setImage1(null);
        setImage2(null);
        setImage3(null);
      }
    });
  };

  const onSubmitVideoBanner = () => {
    const params = {
      title: titleV,
      title_vi: titleVVie,
      link: linkV,
      images: [],
    };

    if (imageV)
      params.images.push({
        field: 'video_background',
        image: imageV,
      });

    updateData(
      'put',
      'video-banner/1',
      params,
      'video_banner',
      (isError, error) => {
        if (isError) {
          notifyError(error);
        } else {
          notifySuccess('Update video banner successfully');
          setImageV(null);
        }
      }
    );
  };

  return (
    <Fragment>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitIntroduction();
        }}
      >
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Introduction Info</h4>
              </div>
              <div className="card-body position-relative">
                {updating && <PageLoader />}
                <div className="basic-form">
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Title (ENG)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Title (VIE)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={titleVie}
                        onChange={(e) => setTitleVie(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label>Link</label>
                      <input
                        type="text"
                        className="form-control"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label>Describe (ENG)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={describe}
                        onChange={(e) => setDescribe(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label>Describe (VIE)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={describeVie}
                        onChange={(e) => setDescribeVie(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Change Introduction Image 1 (16:9)
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(e) => setImage1(e.target.files[0])}
                        />
                      </div>
                      {intro_image1?.path && (
                        <div>
                          <div className="form-group mb-3">
                            <label className="form-label col-12">
                              Current Introduction Image 1
                            </label>
                            <img
                              className="img-responsive"
                              width={'100%'}
                              src={fullBackendPath(intro_image1?.path)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Change Introduction Image 2 (16:9)
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(e) => setImage2(e.target.files[0])}
                        />
                      </div>
                      {intro_image2?.path && (
                        <div>
                          <div className="form-group mb-3">
                            <label className="form-label col-12">
                              Current Introduction Image 2
                            </label>
                            <img
                              className="img-responsive"
                              width={'100%'}
                              src={fullBackendPath(intro_image2?.path)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <div className="mb-3">
                        <label className="form-label">
                          Change Introduction Image 3 (16:9)
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={(e) => setImage3(e.target.files[0])}
                        />
                      </div>
                      {intro_image3?.path && (
                        <div>
                          <div className="form-group mb-3">
                            <label className="form-label col-12">
                              Current Introduction Image 3
                            </label>
                            <img
                              className="img-responsive"
                              width={'100%'}
                              src={fullBackendPath(intro_image3?.path)}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn btn-primary">
                    Save Introduction
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmitVideoBanner();
        }}
      >
        <div className="row mt-5">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Video Banner</h4>
              </div>
              <div className="card-body position-relative">
                {updating && <PageLoader />}
                <div className="basic-form">
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Title (ENG)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={titleV}
                        onChange={(e) => setTitleV(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Title (VIE)</label>
                      <input
                        type="text"
                        className="form-control"
                        value={titleVVie}
                        onChange={(e) => setTitleVVie(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label>Link</label>
                      <input
                        type="text"
                        className="form-control"
                        value={linkV}
                        onChange={(e) => setLinkV(e.target.value)}
                      />
                    </div>
                    <div className="form-group mb-3 col-md-12">
                      <label className="form-label">
                        Change Video Banner Image
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={(e) => setImageV(e.target.files[0])}
                      />
                    </div>
                    {video_background?.path && (
                      <div className="form-group mb-3 col-md-12">
                        <label className="form-label col-12">
                          Current Video Banner Image
                        </label>
                        <div className="col-md-6 offset-md-3">
                          <img
                            className="img-responsive"
                            width={'100%'}
                            src={fullBackendPath(video_background?.path)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="text-center mt-3">
                  <button type="submit" className="btn btn-primary">
                    Save Video Banner
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  intro_section: state.admin.intro_section,
  video_banner: state.admin.video_banner,
  updating: state.admin.updating,
});

const mapDispatchToProps = (dispatch) => ({
  updateData: (method, url, params, field, callback) =>
    dispatch(AdminActions.updateData(method, url, params, field, callback)),
});

const withErrorBoundary = (props) => (
  <ErrorBoundary>
    <Page {...props} />
  </ErrorBoundary>
);

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary);
